<template>
  <div>
    <el-dialog v-model="obj.dialogFormVisible" :close-on-click-modal="false" title="自选" :width="'1000px'">
      <el-tag type="warning" size="small"
        style="margin-right: 100px; margin-bottom: 20px; float: right;">添加或删除后，请务必点击保存按钮</el-tag>
      <div class="edit_dev" style="text-align: center;">
        <el-transfer v-model="obj.leftValue" style="text-align: left; display: inline-block;" filterable
          filter-placeholder="搜索名称" target-order="push" :titles="['主力合约', '自选']" :button-texts="['', '']" :format="{
      noChecked: '${total}',
      hasChecked: '${checked}/${total}',
    }" :data="obj.data" @change="handleChange" @right-check-change="rightCheckChange">
          <template #left-footer>
            <el-button class="transfer-footer" size="small" @click="handleReset">重置</el-button>
          </template>
          <template #right-footer>
            <el-button class="transfer-footer" size="small" @click="handleSubmit">保存</el-button>
            <el-button class="transfer-footer" size="small" @click="handleUp">上移</el-button>
            <el-button class="transfer-footer" size="small" @click="handleDown">下移</el-button>
            <el-button class="transfer-footer" size="small" @click="handleTop">置顶</el-button>
            <el-button class="transfer-footer" size="small" @click="handleBottom">置底</el-button>
          </template>
        </el-transfer>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, nextTick, $forceUpdate } from "vue";
import { useRouter, useRoute } from 'vue-router'
import { http, httpNoLoading } from '../util/http'
import { ElMessage } from 'element-plus'
import { zIndexUp, zIndexDown, zIndexTop, zIndexBottom } from '../util/base'
export default {
  props: {
    visible: {
      type: String,
      default: false
    }
  },
  setup(props) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const route = useRoute()
    const obj = reactive({
      leftValue: [],
      rightValue: [],
      data: [],
      dialogFormVisible: props.visible,
    })

    // 页面传来的事件处理
    vueEvent.on('favoritesDialogVisible', (flag) => {
      obj.dialogFormVisible = flag
      if (flag == true) {
        handleReset()
      }
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderData()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('favoritesDialogVisible', () => { })
    })

    // 获取数据渲染下拉框
    const renderData = () => {
      let formData = new FormData()
      formData.append("category", "main")
      http({
        url: '/contract',
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        res.data.data.forEach((item) => {
          obj.data.push({ 'key': item['name'] + ' ' + item['symbol'], 'label': item['name'] + ' ' + item['symbol'] })
        })
      })
      http({
        url: '/favorites',
        method: 'post',
      }).then((res) => {
        console.log(res)
        obj.leftValue = res.data.data.split(',')
      })
    }

    // 重置画面事件
    const handleReset = (e) => {
      obj.leftValue = []
      obj.rightValue = []
      obj.data = []
      renderData()
    }

    // 按钮提交事件
    const handleSubmit = (e) => {
      // console.log(obj.leftValue)
      sendPost()
    }

    // 上移事件
    const handleUp = (e) => {
      for (var x of obj.rightValue) {
        var index = obj.leftValue.indexOf(x)
        obj.leftValue = zIndexUp(obj.leftValue, index, obj.leftValue.length)
      }
    }

    // 下移事件
    const handleDown = (e) => {
      for (var x of obj.rightValue) {
        var index = obj.leftValue.indexOf(x)
        obj.leftValue = zIndexDown(obj.leftValue, index, obj.leftValue.length)
      }
    }

    // 置顶事件
    const handleTop = (e) => {
      for (var x of obj.rightValue) {
        var index = obj.leftValue.indexOf(x)
        obj.leftValue = zIndexTop(obj.leftValue, index, obj.leftValue.length)
      }
    }

    // 置底事件
    const handleBottom = (e) => {
      for (var x of obj.rightValue) {
        var index = obj.leftValue.indexOf(x)
        obj.leftValue = zIndexBottom(obj.leftValue, index, obj.leftValue.length)
      }
    }

    // 右侧列表元素被用户选中 / 取消选中时触发
    const rightCheckChange = (e) => {
      obj.rightValue = e
    }

    // 右侧列表元素变化时触发
    const handleChange = (e) => {
      // console.log(e)
      // obj.rightValue = e
    }

    // 提交后台
    const sendPost = () => {
      let formData = new FormData()
      formData.append("favorites", obj.leftValue)
      httpNoLoading({
        url: `/favorites_update`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success("操作成功")
        handleReset()
        obj.dialogFormVisible = false
        vueEvent.emit('favoritesDialogClose', '')
      })
    }

    return {
      obj,
      handleReset,
      handleSubmit,
      handleChange,
      rightCheckChange,
      handleUp,
      handleDown,
      handleTop,
      handleBottom
    }
  }
}
</script>
<style scoped>
.edit_dev>>>.el-transfer-panel {
  width: 300px;
}
</style>
